import Raven from 'raven-js';
import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';

// import {
//   injectCustomFontFallbackCss,
//   formatVariant,
//   getVariantStyles,
// } from 'ContentComponents/cmv2/fontPicker/utils';
import UIImage from 'UIComponents/image/UIImage';
import { jsx as _jsx } from "react/jsx-runtime";
class CustomFontOption extends Component {
  constructor(props) {
    super(props);
    this.onSvgError = this.onSvgError.bind(this);
    this.state = {
      useFallback: false
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  onSvgError() {
    const {
      font,
      variant
    } = this.props;
    const {
      family
    } = font || {};
    Raven.captureMessage('Missing valid Custom font SVG', {
      extra: {
        family,
        variant
      }
    });
    this.setState({
      useFallback: true
    });
  }
  renderFallback() {
    const {
      font /* variant */
    } = this.props;
    const {
      family /* variants */
    } = font || {};
    // injectCustomFontFallbackCss(family, variants);
    // if (variant) {
    //   return (
    //     <span style={{ fontFamily: family, ...getVariantStyles(variant) }}>
    //       {formatVariant(variant)}
    //     </span>
    //   );
    // }
    return /*#__PURE__*/_jsx("span", {
      style: {
        fontFamily: family
      },
      children: family
    });
  }
  render() {
    const {
      font,
      variant
    } = this.props;
    const {
      defaultSvgUrl,
      svgUrls = {}
    } = font;
    const svgUrl = variant ? svgUrls[variant] : defaultSvgUrl;
    if (this.state.useFallback || !svgUrl) {
      return this.renderFallback();
    }
    return /*#__PURE__*/_jsx(UIImage, {
      className: "google-font-svg",
      onError: this.onSvgError,
      src: svgUrl
    });
  }
}
export default CustomFontOption;